module.exports = __webpack_public_path__ + "assets/img/29_416_big.a5507c9f.jpg";